<template>
  <div class="container mt-3" v-if="appStatus.statusCode > 0">
    <b-alert id="sta-alert"
             :variant="alertClass"
             dismissible
             show
             fade>
      <div>
        <span id="sta-code">Status code: {{ appStatus.statusCode }}</span>
        <br>
        <span id="sta-message">Message: {{ appStatus.statusMessage }}</span>
      </div>
    </b-alert>
  </div>
</template>

<script>
import { eventBus } from '../main';

export default {
  name: 'StatusAlert',
  data() {
    return {
      appStatus: {
        statusCode: 0,
        statusMessage: '',
      },
      alertClass: '',
    };
  },
  created() {
    eventBus.$on('statusShouldBeDisplayed', () => {
      this.appStatus = eventBus.appStatus;
      if (this.appStatus.statusCode.toString().match(/20[0-9]/)) {
        this.alertClass = 'success';
      } else {
        this.alertClass = 'danger';
      }
    });
    eventBus.$on('statusIsCleared', () => {
      this.appStatus = eventBus.appStatus;
    });
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/StatusAlert.vue